import { render, staticRenderFns } from "./OnBoardWelcomePage.vue?vue&type=template&id=3a087fca&scoped=true"
import script from "./OnBoardWelcomePage.vue?vue&type=script&lang=js"
export * from "./OnBoardWelcomePage.vue?vue&type=script&lang=js"
import style0 from "./OnBoardWelcomePage.vue?vue&type=style&index=0&id=3a087fca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a087fca",
  null
  
)

export default component.exports